import * as yup from "yup";

declare module "yup" {
   export interface StringSchema {
      /**
       * Check for phone number validity.
       *       
       * @param {Boolean} [required=false] Is fullname required.
       * @param {String} [errorMessage=DEFAULT_MESSAGE] The error message to return if the validation fails.
       */
      inDomains(
         domains?: Array<string> | undefined,
         errorMessage?: string
      ): StringSchema;
   }
}
const YUP_IN_DOMAINS_METHOD = "inDomains";
yup.addMethod(yup.string, YUP_IN_DOMAINS_METHOD, function yupInDomains(
   domains: Array<string>,
   errorMessage = ""
) {
   const errMsg =
      typeof errorMessage === "string" && errorMessage
         ? errorMessage
         : "Email is not a part of your email domains.";

   return this.test(YUP_IN_DOMAINS_METHOD, errMsg, (value: string) => {
      if (!value)
         return true;
      if (!domains || !domains.length)
         return true;

      const domainIndex = value.indexOf("@");
      if (domainIndex < 0)
         return false;

      if (domainIndex + 1 == value.length)
         return false;

      const domain = value.substr(domainIndex + 1)?.toLowerCase() || "";
      return domains.map(d => d?.toLowerCase() ?? "").includes(domain);
   });
});
